<template>
  <div class="order-search">
    <div class="mr12 mb12">
      <el-select
        @change="val => this.handleChange(1)"
        v-model="curQueryType"
        placeholder="请选择"
        class="querySelect mr12"
      >
        <el-option v-for="item in queryType" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-input
        clearable
        v-model="queryTypeValue"
        class="queryInputSmall"
        :placeholder="queryTypeHolder"
        :maxlength="orderNoLimit70"
        :show-word-limit="showOrderNoLimit70"
      />
    </div>
    <div class="mr12 mb12">
      <el-select v-model="curQueryTimeType" placeholder="请选择" class="querySelect mr12">
        <el-option v-for="item in queryTimeType" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-date-picker
        v-model="queryTimeTypeValue"
        class="queryInput"
        type="datetimerange"
        align="right"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :default-time="['00:00:00', '23:59:59']"
        value-format="yyyy-MM-dd HH:mm:ss"
        clearable
      ></el-date-picker>
    </div>
    <div class="mr12 mb12" v-if="needOrderStatus()">
      <el-select
        v-model="queryOrderStatusValue"
        placeholder="订单状态"
        style="width: 180px"
        clearable
        multiple
        collapse-tags
      >
        <el-option
          v-for="item in orderStatusOptions()"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>
    <div class="mr12 mb12" v-if="pageEntry === 'list'">
      <el-select v-model="queryOrderSaleValue" placeholder="售后状态" style="width: 180px" clearable>
        <el-option
          v-for="item in orderRefundStatus"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>
    <div class="mr12 mb12">
      <el-button type="primary" @click="handleSearch">搜索</el-button>
      <el-button @click="resetSearch">重置</el-button>
    </div>
  </div>
</template>
<script>
import {
  queryType,
  tabMode,
  queryTimeType,
  orderListColumns,
  orderStatus,
  orderStatusByUnpaid,
  orderRefundStatus
} from '../config/index'
import moment from 'moment'
const defaultTime = [
  moment()
    .subtract(6, 'days')
    .format('YYYY-MM-DD 00:00:00'),
  moment().format('YYYY-MM-DD 23:59:59')
]
const DEFAULT_ORDER_STATUS = ['TO_BE_SHIPPED', 'SHIPPED']
export default {
  name: 'OrderSearch',
  props: ['pageEntry', 'activeTab'],
  data() {
    return {
      queryType,
      queryTimeType,
      orderRefundStatus,
      tabMode,
      curQueryType: queryType[0].value,
      curQueryTimeType: queryTimeType[0].value,
      curQueryPayStatusValue: '',
      queryTypeValue: '',
      queryTimeTypeValue: [...defaultTime],
      queryShopmentValue: '',
      queryOrderStatusValue:
        this.activeTab === 'all' ? JSON.parse(JSON.stringify(DEFAULT_ORDER_STATUS)) : JSON.parse(JSON.stringify([])),
      queryOrderSaleValue: ''
    }
  },
  computed: {
    queryTypeHolder() {
      return this.queryType.find(item => item.value === this.curQueryType).placeholder
    },
    orderNoLimit70() {
      return this.curQueryType === 'ORDER_NO' ? 70 : ''
    },
    showOrderNoLimit70() {
      return this.curQueryType === 'ORDER_NO'
    }
  },
  mounted() {
    if (this.$route.query && this.$route.query.isToday) {
      this.queryTimeTypeValue = [moment().format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')]
      this.$route.query.isToday = null
    }
  },
  methods: {
    resetSearch() {
      this.curQueryType = queryType[0].value
      this.curQueryTimeType = queryTimeType[0].value
      this.queryTypeValue = ''
      this.queryOrderSaleValue = ''
      this.queryTimeTypeValue = [...defaultTime]
      if (this.activeTab === 'all') {
        this.queryOrderStatusValue = JSON.parse(JSON.stringify(DEFAULT_ORDER_STATUS))
      }
      if (this.pageEntry === 'unpaid') {
        this.queryOrderStatusValue = JSON.parse(JSON.stringify([]))
      }

      const submitData = this.getSearchParams()
      this.$emit('getList', submitData, true)
    },
    needOrderStatus() {
      return this.activeTab !== 'SHIPPED' && this.activeTab !== 'TO_BE_SHIPPED'
    },
    orderStatusOptions() {
      if (!this.activeTab && this.pageEntry === 'unpaid') {
        return orderStatusByUnpaid
      }
      return orderStatus
    },
    getSearchParams() {
      const data = {
        queryType: this.curQueryType,
        refundStatus: this.queryOrderSaleValue,
        keyword: this.queryTypeValue,
        payTimeStart: this.curQueryTimeType === 'payTime' && this.queryTimeTypeValue ? this.queryTimeTypeValue[0] : '',
        payTimeEnd: this.curQueryTimeType === 'payTime' && this.queryTimeTypeValue ? this.queryTimeTypeValue[1] : '',
        createTimeStart:
          this.curQueryTimeType === 'createdTime' && this.queryTimeTypeValue ? this.queryTimeTypeValue[0] : '',
        createTimeEnd:
          this.curQueryTimeType === 'createdTime' && this.queryTimeTypeValue ? this.queryTimeTypeValue[1] : ''
      }
      if (this.queryOrderStatusValue.length) data['orderStatus'] = this.queryOrderStatusValue
      return data
    },
    handleChange(type) {
      if (type && type === 1) {
        this.queryTypeValue = ''
      }
    },
    handleSearch() {
      const submitData = this.getSearchParams()
      this.$emit('getList', submitData, true)
    }
  }
}
</script>
<style lang="scss" scoped>
.ml12 {
  margin-left: 12px;
}
.mr12 {
  margin-right: 12px;
}
.mb12 {
  margin-bottom: 12px;
}
.mb16 {
  margin-bottom: 16px;
}

.order-search {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  .querySelect {
    width: 120px;
  }
  .queryInput {
    width: 390px;
    // margin-left: 6px;
  }
  .queryInputSmall {
    width: 260px;
    // margin-left: 6px;
  }
}
</style>
